<template>
  <div id="clients-list">

    <div v-if="isLoading || (productsAux && productsAux.length === 0)">
      <div class="progress-bar-container">
        <div class="progress-bar"></div>
      </div>
    </div>

    <div v-else class="row">
      <div class="col-12">
        <table class="table" v-if="$store.state.responsive.viewDesktopLists">
          <thead class="fixheader">
            <tr>
              <th scope="col" class="align-middle">
                <ThOrder
                  :textHeader="'Marca'"
                  :idHeader="'brand'"
                  :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"
                ></ThOrder>
              </th>
              <th scope="col" class="align-middle">
                <ThOrder
                  :textHeader="'Modelo'"
                  :idHeader="'model'"
                  :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"
                ></ThOrder>
              </th>
              <th scope="col" class="align-middle">
                <ThOrder
                  :textHeader="'Capacidad'"
                  :idHeader="'capacity'"
                  :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"
                ></ThOrder>
              </th>
              <th scope="col" class="align-middle">
                <ThOrder
                  :textHeader="'Color'"
                  :idHeader="'color'"
                  :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"
                ></ThOrder>
              </th>
              <th
                scope="col"
                class="align-middle"
                v-if="!$store.state.roles.Backoffice_member_empresas"
              >
                <ThOrder
                  :textHeader="'Stock'"
                  :idHeader="'stock'"
                  :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"
                ></ThOrder>
              </th>
              <th scope="col" class="align-middle">
                <ThOrder
                  :textHeader="'Cuota mensual'"
                  :idHeader="'cuota'"
                  :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"
                ></ThOrder>
              </th>
              <th
                scope="col"
                class="align-middle py-4"
                v-if="$store.state.roles.Backoffice_member_empresas"
              >
                <ThOrder
                  :textHeader="'Unidades'"
                  :idHeader="'stock'"
                  :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"
                ></ThOrder>
              </th>
              <th
                scope="col"
                class="align-middle py-4"
                v-if="$store.state.roles.Backoffice_member_empresas"
              >
                <ThOrder
                  :textHeader="'Cantidad'"
                  :idHeader="'stock'"
                  :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"
                ></ThOrder>
              </th>
              <th
                scope="col"
                class="align-middle py-4"
                v-if="!$store.state.roles.Backoffice_member_empresas"
              >
                Operaciones
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in productsAux" v-bind:key="product.clientId">
              <td class="align-middle py-4">{{ product.brand }}</td>
              <td class="align-middle py-4">{{ product.model }}</td>
              <td class="align-middle py-4">{{ product.capacity }}</td>
              <td class="align-middle py-4">{{ product.color }}</td>
              <td class="align-middle py-4" v-if="!$store.state.roles.Backoffice_member_empresas">
                <div v-if="product.stock > 0" class="stockTable">Sí</div>
                <div v-else class="noStockTable">No</div>
              </td>
              <td class="align-middle py-4">{{ product.totalPrice }}€</td>
              <td class="align-middle py-4" v-if="$store.state.roles.Backoffice_member_empresas">
                <div v-if="product.stock <= 0">
                  <div class="noStockTable text-nowrap">Sin stock</div>
                </div>
                <div v-else class="stockAble">
                  {{ product.stock }}
                </div>
              </td>
              <td class="align-middle py-4">
                <button
                  v-if="product.stock > 0 && !$store.state.roles.Backoffice_member_empresas"
                  @click="selectProduct(product.ean)"
                  class="btn generalTertiaryButton"
                >
                  Seleccionar
                </button>
                <NumberInput
                  v-if="product.stock > 0 && $store.state.roles.Backoffice_member_empresas"
                  @selectProductBusiness="
                    selectProductBusiness($event, product.ean, product.price)
                  "
                  @changeProductBusiness="
                    changeProductBusiness($event, product.ean)
                  "
                  @deleteProductBusiness="deleteProductBusiness(product.ean)"
                  :added="comprobarEan(product.ean)"
                  :amount="comprobarCantidad(product.ean)"
                  :maxValue="product.stock"
                >
                </NumberInput>
              </td>
            </tr>
          </tbody>
        </table>
        <template v-if="!$store.state.responsive.viewDesktopLists">
          <div
            class="card p-2 mb-3"
            v-for="product in productsAux"
            v-bind:key="product.clientId"
          >
            <div class="list-item">
              <div
                class="item d-flex align-items-center justify-content-between collapsed px-2 py-3"
                data-toggle="collapse"
                :href="'#collapseExample' + index"
                role="button"
                aria-expanded="true"
                :aria-controls="'collapseExample' + index"
              >
                <h4 class="m-0">
                  {{ product.brand }} {{ product.model }}
                  {{ product.capacity }} {{ product.color }}
                </h4>
                <v-icon name="bi-chevron-up" />
              </div>
              <div
                class="collapse show ml-3 mr-2"
                :id="'collapseExample' + index"
              >
                <div
                  class="d-flex align-items-center justify-content-between flex-wrap mb-2 mt-2"
                >
                  <div class="d-flex align-items-center justify-content-start">
                    <p class="m-0 mr-2">
                      <strong>Marca: </strong>{{ product.brand }}
                    </p>
                  </div>
                </div>
                <div
                  class="d-flex align-items-center justify-content-start flex-wrap mb-2"
                >
                  <p class="m-0 mr-2">
                    <strong>Modelo: </strong>{{ product.model }}
                  </p>
                </div>
                <div
                  class="d-flex align-items-center justify-content-start flex-wrap mb-2"
                >
                  <p class="m-0 mr-2">
                    <strong>Capacidad: </strong>{{ product.capacity }}
                  </p>
                </div>
                <div
                  class="d-flex align-items-center justify-content-start flex-wrap mb-2"
                >
                  <p class="m-0 mr-2">
                    <strong>Color: </strong>{{ product.color }}
                  </p>
                </div>
                <div
                  v-if="!$store.state.roles.Backoffice_member_empresas"
                  class="d-flex align-items-center justify-content-start flex-wrap mb-2"
                >
                  <p class="m-0 mr-2"><strong>Stock: </strong></p>
                  <span v-if="product.stock > 0" class="stockTable">Sí</span>
                  <span v-else class="noStockTable">No</span>
                </div>
                <div
                  class="d-flex align-items-center justify-content-start flex-wrap mb-2"
                >
                  <p class="m-0 mr-2">
                    <strong>Cuota mensual: </strong>{{ product.totalPrice }}€
                  </p>
                </div>
                <div
                  v-if="$store.state.roles.Backoffice_member_empresas"
                  class="d-flex align-items-center justify-content-start flex-wrap mb-2"
                >
                  <p class="m-0 mr-2"><strong>Unidades: </strong></p>
                  <div v-if="product.stock <= 0">
                    <div class="noStockTable text-nowrap">Sin stock</div>
                  </div>
                  <div v-else>
                    {{ product.stock }}
                  </div>
                </div>
                <div
                  class="d-flex align-items-center justify-content-start flex-wrap mb-2"
                >
                  <p
                    v-if="$store.state.roles.Backoffice_member_empresas && product.stock > 0"
                    class="m-0 mr-4"
                  >
                    <strong>Cantidad: </strong>
                  </p>
                  <button
                    v-if="product.stock > 0 && !$store.state.roles.Backoffice_member_empresas"
                    @click="selectProduct(product.ean)"
                    class="btn generalTertiaryButton"
                  >
                    Seleccionar
                  </button>
                  <NumberInput
                    v-if="product.stock > 0 && $store.state.roles.Backoffice_member_empresas"
                    @selectProductBusiness="
                      selectProductBusiness($event, product.ean, product.price)
                    "
                    @changeProductBusiness="
                      changeProductBusiness($event, product.ean)
                    "
                    @deleteProductBusiness="deleteProductBusiness(product.ean)"
                    :added="comprobarEan(product.ean)"
                    :amount="comprobarCantidad(product.ean)"
                    :maxValue="product.stock"
                  >
                  </NumberInput>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ThOrder from "../../../../Shared/ThOrder.vue";
import NumberInput from "./NumberInput.vue";
import axios from "axios";
import eventBus from "../../../../Shared/eventBus.js";

export default {
  name: "NewContractProductList",
  props: ["products", "loading"],
  data() {
    return {
      productsStore: this.$store.state.newContractData.product,
      currentOrder: "",
      currentOrderBy: "",
      productsAux: this.products || [],
      productsSelected: [],
      productsStoreAux: Array.isArray(this.$store.state.newContractData.product)
        ? this.$store.state.newContractData.product
        : [],
      isLoading: this.loading || true,
    };


  },
  watch: {
    loading(newVal) {
      this.isLoading = newVal;
    },
    productsAux(newProducts) {
      if (Array.isArray(newProducts) && newProducts.length > 0) {
        this.isLoading = false;
        eventBus.emit('productsLoaded');
      } else {
        this.isLoading = true;
      }
    }
  },
  mounted() {
    if (!Array.isArray(this.productsAux) || this.productsAux.length === 0) {
      this.isLoading = true;
    }
  },
  created() {
    this.$store.subscribe((mutation, payload) => {
      if (mutation.type == "setNewContractDataProduct") {
        this.productsStoreAux = payload.newContractData.product;
        console.log("Cargamos......")
      }
    });
  },
  updated() {
    this.productsAux = this.products;
  },
  components: {
    ThOrder,
    NumberInput,
  },
  methods: {
    deepClone(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    async selectProduct(ean) {
      console.time('Tiempo de carga del producto por EAN');
      axios.get(`/products/get-by-ean/${ean}`).then(async (response) => {
        const bodyToSave = {
          id: response.data.id,
          supplier: response.data.merchantData.merchant,
          brand: response.data.brand,
          model: response.data.model,
          capacity: response.data.capacity,
          ean: response.data.merchantData.ean,
          color: response.data.color,
          price:
            response.data.prices.payment.totalFee *
            response.data.prices.payment.fees,
          nQuotas: response.data.prices.payment.fees,
          quotaPrice: response.data.prices.payment.totalFee,
          stock: response.data.stock,
        };
        const bodyCustomerNew = {
          name: "",
          surname1: "",
          surname2: "",
          birthdate: "",
          email: "",
          phone: "",
          fixPhone: "",
          documentNumber: "",
          documentType: "",
          language: "",
          deliveryAddress: {
            street: "",
            number: "",
            door: "",
            floor: "",
            stair: "",
            city: "",
            state: "",
            country: "",
            postalCode: "",
          },
          billingAddress: {
            sameAddress: false,
            street: "",
            number: "",
            door: "",
            floor: "",
            stair: "",
            city: "",
            state: "",
            country: "",
            postalCode: "",
          },
        };
        this.$store.commit("setNewContractDataCustomer", bodyCustomerNew);
        this.$store.commit("setNewContractDataProduct", bodyToSave);
        console.timeEnd('Tiempo de carga del producto por EAN');

        this.$router.push({ name: "newContractStep2" });
      });
    },
    selectOrder(value) {
      this.productsAux = this.productsAux.sort(function (a, b) {
        let valorA =
          a[value.orderBy] == null || a[value.orderBy] == undefined
            ? 0
            : a[value.orderBy];
        let valorB =
          b[value.orderBy] == null || b[value.orderBy] == undefined
            ? 0
            : b[value.orderBy];
        if (value.orderBy == "capacity") {
          valorA = parseInt(a[value.orderBy].slice(0, -2));
          valorB = parseInt(b[value.orderBy].slice(0, -2));
        }
        if (valorA < valorB) return -1;
        if (valorA > valorB) return 1;
      });
      if (value.order == "DESC") this.productsAux = this.productsAux.reverse();
    },
    comprobarEan(ean) {
      let response = false;
      this.productsStoreAux.forEach((value) => {
        if (value.ean == ean) response = true;
      });
      return response;
    },
    comprobarCantidad(ean) {
      if (Array.isArray(this.productsStoreAux)) {
        const productoEncontrado = this.productsStoreAux.find(
          (producto) => producto.ean === ean
        );
        if (productoEncontrado) {
          return productoEncontrado.quantity;
        }
      }
      return 0;
    },
    selectProductBusiness(event, ean, monthlyNetFeeValue) {
      axios.get(`/products/get-by-ean/${ean}`).then(async (response) => {
        let newProduct = {
          partCode: response.data.merchantData.merchantCode,
          retailPrice: 0,
          name: response.data.name,
          quantity: event.amount,
          stock: response.data.stock,
          ean,
          policy: {
            monthlyNetPolicy: 0,
            monthlyGrossPolicy: 0,
            replacementExcess: 0,
            repairExcess: 0,
          },
          payment: {
            rentServ: 0,
            monthlyNetFee: monthlyNetFeeValue,
          },
          policyOptions: response.data.policyOptions,
        };
        let productStore = this.productsStoreAux;
        productStore.push(newProduct);
        this.$store.commit("setNewContractDataProduct", productStore);
      });
    },
    changeProductBusiness(event, ean) {
      const indexToUpdate = this.productsStoreAux.findIndex(
        (product) => product.ean === ean
      );
      let productsSelected = this.productsStoreAux;

      if (indexToUpdate !== -1) {
        productsSelected[indexToUpdate].quantity = event.amount;
        this.$store.commit("setNewContractDataProduct", productsSelected);
      }
    },
    deleteProductBusiness(ean) {
      // retorna todos los productos que tengan un partCode distinto
      const productsSelected = this.productsStoreAux.filter(
        (producto) => producto.ean !== ean
      );
      this.$store.commit("setNewContractDataProduct", productsSelected);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#operaciones {
  text-align: right;
}

thead {
  background-color: rgb(250, 250, 250);
}

.col-12 {
  padding: 0%;
}

.progress-bar-container {
  width: 100%;
  height: 4px;
  background-color: #f3f3f3;
  position: relative;
  margin-bottom: 10px;
}

.progress-bar {
  width: 0;
  height: 100%;
  background-color: #97055D;
  animation: loading 2s infinite;
}

@keyframes loading {
  0% {
    width: 0;
  }
  50% {
    width: 50%;
  }
  100% {
    width: 100%;
  }
}
</style>
